export const SECTION_SERVICE_FILL_CONSTANTS = {
  EMIT: {
    REFRESH_SERVICES: "refreshServices",
    REFRESH_SERVICE_DATA: "refreshServiceData"
  }
};
